// [BD Feat] Success Gallery JS

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".gallery-item");
  const paginationContainer = document.getElementById("pagination");

  let itemsPerPage;
  let totalPages;

  if (!items.length) return;

  function getItemsPerPage() {
    return window.innerWidth <= 768 ? 10 : 8;
  }

  function showPage(page) {
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;

    items.forEach((item, index) => {
      item.style.display = index >= start && index < end ? "block" : "none";
    });

    // Highlight active page
    document.querySelectorAll(".pagination-button").forEach((btn) => {
      btn.classList.remove("active");
      if (parseInt(btn.textContent) === page) {
        btn.classList.add("active");
      }
    });
  }

  function createPagination() {
    paginationContainer.innerHTML = ""; // Clear existing buttons

    for (let i = 1; i <= totalPages; i++) {
      const btn = document.createElement("button");
      btn.className = "pagination-button";
      btn.textContent = i;
      btn.addEventListener("click", () => showPage(i));
      paginationContainer.appendChild(btn);
    }
  }

  function initPagination() {
    itemsPerPage = getItemsPerPage();
    totalPages = Math.ceil(items.length / itemsPerPage);

    if (items.length > itemsPerPage) {
      paginationContainer.style.display = "flex";
      createPagination();
    } else {
      paginationContainer.style.display = "none";
    }

    showPage(1);
  }

  // Initialize on load
  initPagination();

  // Recalculate on resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initPagination();
    }, 200);
  });


  document.querySelectorAll('.success-gallary-image').forEach((galleryItem) => {
    galleryItem.addEventListener('click', () => {
      const blockId = galleryItem.getAttribute('data-id');
      const modal = document.getElementById(`Modal-${blockId}`);
      if (modal) {
        document.body.classList.add('story__modal--opened');
        modal.classList.add('open');
      }
    });
  });

  document.querySelectorAll('.story__modal-close').forEach((closeButton) => {
    closeButton.addEventListener('click', (e) => {
      e.stopPropagation(); // Prevent bubbling
      document.body.classList.remove('story__modal--opened');
      const modal = closeButton.closest('.story__modal');
      if (modal) {
        modal.classList.remove('open');
      }
    });
  });

});
